import request from "@/utils/request";

// 获取填报须知
const getReportingRemarkApi = (province) => {
  return request.get(
    "/api/remark-configs/instructions-for-reporting?province=" + province
  );
}

// 获取等效分说明
const getScoreRemarkApi = (province) => {
  return request.get(
    "/api/remark-configs/equivalent-score-description?province=" + province
  );
}

/**
 * 等效分/等位分展示
 * @param {*} province 
 * @returns eqScore 等效分 eqRankScore 同位分
 */
const getScoreShowTypeApi = (province) => {
  return request.get(
    `/api/remark-configs/province/equivalent-score-show?province=${province}`
  );
}

export {
  getReportingRemarkApi,
  getScoreRemarkApi,
  getScoreShowTypeApi
}
